<template>
  <div>
    <HeaderCreditor header="รายละเอียดการชำระเงิน" :img_header="header_image" link_back="creditor/transferfromdebtor"/>
    <Transfer_correct/>
  </div>
</template>

<script>
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor";
import HeaderImage from "@/assets/money_creditor.png";
import Transfer_correct from "@/components/admin/creditor/Transfer_correct";
export default {
  name: "TransferCorrect",
  components: {
    Transfer_correct,
    HeaderCreditor
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
